<!--
/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */
-->

<template>
    <router-view />
    <CommonCookiesManager />
</template>

<script setup lang="ts">
import CommonCookiesManager from './components/common/CommonCookiesManager.vue';
</script>

<style lang="sass">
</style>
